import { validMobile, validPhone, validEmail } from '@/utils/common/index'
import AreaPicker from '@/components/select/area-picker/area-picker.vue'
export default [
  {
    mapKey: 'number',
    formItem: {
      component: 'el-input-number',
      controlsPosition: 'right',
      style: { width: '100%' }
    }
  },
  {
    mapKey: 'textarea',
    formItem: {
      component: 'el-input',
      type: 'textarea',
      autosize: { minRows: 1 }
    }
  },
  {
    prop: 'remarks',
    label: 'common.remarks',
    formItem: {
      component: 'el-input',
      type: 'textarea',
      autosize: { minRows: 1 }
    }
  },
  {
    mapKey: 'mobile',
    formItem: {
      component: 'el-input'
    },
    rules: { validator: validMobile, trigger: 'blur' }
  },
  {
    mapKey: 'phone',
    formItem: {
      component: 'el-input'
    },
    rules: { validator: validPhone, trigger: 'blur' }
  },
  {
    mapKey: 'email',
    formItem: {
      component: 'el-input'
    },
    rules: { validator: validEmail, trigger: 'blur' }
  },
  {
    mapKey: 'area',
    formItem: {
      component: AreaPicker,
      clearable: true
    }
  }
]
